// extracted by mini-css-extract-plugin
export var externalLink = "_ds-0";
export var internalLinkLabel = "_ds-1";